import { getViewerIdAndKind, isBarberSessionView, useSession } from '../../infra/session';
import { useApiQuery } from '../../infra/api';
import { endpoints } from '../network';
export var useBarberType = function () {
    var _a;
    var session = useSession().data;
    var isBarberView = isBarberSessionView(session === null || session === void 0 ? void 0 : session.view);
    var viewerIdAndKind = getViewerIdAndKind(session);
    var barberInfo = useApiQuery({
        endpoint: endpoints.barberQuery,
        payload: {
            barberId: viewerIdAndKind.id,
        },
        options: {
            enabled: isBarberView,
        },
    });
    return (_a = barberInfo.data) === null || _a === void 0 ? void 0 : _a.type;
};
